// Optimized performance utilities - minimal and efficient

// Preload critical resources only
export const preloadCriticalResources = () => {
  if (typeof window !== 'undefined') {
    // Preload hero image
    const heroImageLink = document.createElement('link');
    heroImageLink.rel = 'preload';
    heroImageLink.as = 'image';
    heroImageLink.href = '/assets/hero-background.jpg';
    document.head.appendChild(heroImageLink);
  }
};

// Essential resource hints
export const addResourceHints = () => {
  if (typeof window !== 'undefined') {
    // DNS prefetch for external fonts only
    const fontPreconnect = document.createElement('link');
    fontPreconnect.rel = 'preconnect';
    fontPreconnect.href = 'https://fonts.gstatic.com';
    fontPreconnect.crossOrigin = 'anonymous';
    document.head.appendChild(fontPreconnect);
  }
};

// Initialize only essential optimizations
export const initPerformanceOptimizations = () => {
  preloadCriticalResources();
  addResourceHints();
};